
<template>
<section>
  <div class="tabbed-content">
    <div class="columns">
      <div class="col">
        <chc-input v-model="data.company_name" label="Company Name" :required="true" :error="errors.company_name"></chc-input>
        <chc-input v-model="data.address_street" label="Address" :required="true" :error="errors.address_street"></chc-input>
        <chc-input v-model="data.address_city" label="City" :required="true" :error="errors.address_city"></chc-input>
        <chc-input v-model="data.address_state" label="State" format="combo"
                   :autoCompleteValues="$store.state.constants.us_states_list" :required="true" :error="errors.address_state"></chc-input>
        <chc-input v-model="data.address_zip" label="Zip" format="zip" :required="true" :error="errors.address_zip"></chc-input>
      </div>
      <div class="col">
        <chc-input v-model="data.email" label="Email" :required="true" :error="errors.email"></chc-input>
        <chc-input v-model="data.phone" label="Phone" :required="true" :error="errors.phone"></chc-input>
        <chc-input v-model="data.fax" label="Fax"></chc-input>
      </div>
    </div>
    <div class="columns">
      <div class="col">
        <towing-company-tiers :data="data"></towing-company-tiers>
      </div>
    </div>
    <div class="columns">
      <div class="col">
        <div class="field">
          <span v-if="hasErrors" class="error-message error-block">
            There were errors processing the form. Please fix the fields above.
          </span>
          <input @click="submit" type="submit" class="btn" value="Save Changes">
          <transition name="fade">
            <p v-if="saved" class="success-message">Changes Saved</p>
          </transition>
        </div>
      </div>
    </div>
  </div>
</section>
</template>

<script>
import store from '@/store'
import TowingCompanyTiers from '@/components/TowingCompany/TowingCompanyTiers'

export default {
  name: 'TowingCompanyInformation',
  data () {
    return {
      errors: [],
      hasErrors: false,
      saved: false
    }
  },
  props: ['data', 'towingCompanyId'],
  methods: {
    copyTowingAddress () {
    },
    submit () {
      store.functions.towingCompanies.updateTowingCompany(this.towingCompanyId, this.fixData(this.data), (errors) => {
        this.errors = errors
        this.hasErrors = true
      }).then(() => {
        this.saved = true
        this.errors = {}
        this.hasErrors = false
        this.$emit('refresh')
        setTimeout(() => {
          this.saved = false
        }, 500)
      })
    },
    fixData (data) {
      let a = Object.assign({}, data, { towing_tiers: JSON.stringify(data.towing_tiers) })
      return a
    }
  },
  components: {
    TowingCompanyTiers
  }
}
</script>

<style lang="scss" scoped>
#tier-block {
    display: block;
    width: 60%;
    padding: 0em 1em 2em 1em;
}

.field .left {
    margin-left: 2em;
}
.fade-enter-active, .fade-leave-active {
    opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    transition: opacity 3s;
    opacity: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/TowingCompany/TowingCompanyInformation.vue